import React, { useState } from 'react'
import { MenuSearch } from '@fs/zion-icon'
import { BillboardButton, Row, Separator } from '@fs/zion-ui'
import { useQueryParams, useLocation } from '@fs/zion-router'
import ZionForm, { useZionForm } from '@fs/zion-form'
import { removeEmptyCriteria } from 'helpers/searchQueryHelpers'
import { ClanInput, SurnameInput } from '../FormInputs/FormInputs'
import { useRouterHelper } from '../../hooks'
import transl from './LandingPageJokboSearchForm.transl'

export default function LandingPageJokboSearchForm() {
  const { query } = useQueryParams()
  const { navigate } = useRouterHelper()
  const methods = useZionForm({
    mode: 'all',
    defaultValues: {
      ...query,
    },
  })

  const [surname, setSurname] = useState()
  const [clan, setClan] = useState()

  const location = useLocation()
  const searchResultsPath = `${location.pathname.replace(/\/+$/, '')}/search-results`

  function submitSearchCriteria(values) {
    const searchCriteria = removeEmptyCriteria({
      volumeSetSearch: 'jokbo',
      ...values,
    })
    navigate({ path: searchResultsPath, query: searchCriteria })
  }

  function onSurnameChange(event) {
    setSurname(event.target.value)
  }
  function onClanChange(event) {
    setClan(event.target.value)
  }

  return (
    <>
      {query && (
        <ZionForm methods={methods} onSubmit={submitSearchCriteria}>
          <ClanInput onChange={onClanChange} />
          <SurnameInput onChange={onSurnameChange} />
          <Separator size="md" />
          <Row>
            <BillboardButton Icon={MenuSearch} name="submit" emphasis="lightHigh" type="submit">
              {transl.searchImageGroups()}
            </BillboardButton>
            <BillboardButton
              name="submitAdvanced"
              emphasis="low"
              onClick={() => submitSearchCriteria({ advanced: 'true', surname, clan })}
            >
              {transl.advancedSearch()}
            </BillboardButton>
          </Row>
          <Separator size="lg" />
        </ZionForm>
      )}
    </>
  )
}
